import properties from "$lib/properties";
import { type UserData, userStore } from "$lib/stores/user";
import {
  handleConnectivityErrorInLoader,
  handleStatusErrorInLoader,
} from "$lib/utils/errorManagement/handleErrors";
import client from "$lib/utils/http/client";
import { get } from "svelte/store";
import type { LayoutLoad } from "./$types";
import { redirect } from "@sveltejs/kit";

export const ssr = false;
export const load: LayoutLoad = async function load({ route }) {
  if (route.id !== "/login" && get(userStore) === null) {
    const response = await client.instance
      .get<UserData>(`${properties.serverUrl}/api/users/me`)
      .catch(handleConnectivityErrorInLoader)
      .catch(handleStatusErrorInLoader)
      .catch(() => {
        throw redirect(302, "/login");
      });
    userStore.set(response.data);
  }
  return { properties };
};
